import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import Brand from '../../../../../types/brand/Brand';
import VehicleBrands from '../../../../../types/retailer/VehicleBrands';
import VehicleModel from '../../../../../types/vehicle-model/VehicleModel';
import { RetailerService } from '../../../services/retailer.service';
import { VehicleModelService } from '../../../services/vehicle-model.service';
import { RetailerTopBarComponent } from '../retailer-top-bar/retailer-top-bar.component';

@Component({
    selector: 'app-select-details',
    imports: [
        RetailerTopBarComponent,
        FormsModule
    ],
    templateUrl: './select-details.component.html',
    styleUrls: [ './select-details.component.scss' ]
})
export class SelectDetailsComponent implements OnInit {

    public isManufakturSwitchOn: boolean = true;
    public isStandardSwitchOn: boolean = true;
    public isManufakturExclusiveSwitchOn: boolean = true;

    public vehicleModel: VehicleModel | null = null;
    public brands: Brand[] = [];
    public availableBrandIds: number[] = [];
    public selectedBrand: Brand | undefined = undefined;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private vehicleModelService: VehicleModelService,
                private retailerService: RetailerService,
                private messageService: MessageService) {
    }

    /**
     * Initializes the component.
     */
    public ngOnInit(): void {
        this.fetchVehicleModel();
    }

    /**
     * Selects a brand.
     *
     * @param brand The brand to select.
     */
    public selectBrand(brand: Brand): void {
        this.selectedBrand = brand;
        this.selectVehicleModel();
    }

    /**
     * Fetches the vehicle model from the backend
     */
    private fetchVehicleModel(): void {
        // Fetch the vehicle model from the backend
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            const idNumber = parseInt(id);
            this.vehicleModelService
                .getVehicleModel(idNumber)
                .then((result: VehicleModel) => {
                    this.vehicleModel = result;
                    this.fetchBrands();
                })
                .catch((error: any) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.message,
                        life: 3000,
                    });
                });
        }
    }

    /**
     * Fetches the available brands from the backend
     */
    private fetchBrands(): void {
        if (this.vehicleModel?.bodyType?.name && this.vehicleModel?.carClass?.name && this.vehicleModel?.modelSeries) {
            this.retailerService.getAvailableBrands(
                this.vehicleModel?.bodyType?.name, this.vehicleModel?.carClass?.name, this.vehicleModel?.modelSeries)
                .then((result: VehicleBrands) => {
                    this.brands = result.brands;
                    this.availableBrandIds = result.availableBrandIds;
                    if (this.availableBrandIds.length === 1) {
                        this.selectedBrand = this.brands.find((brand: Brand) => brand.id === this.availableBrandIds[0]);
                        this.selectVehicleModel();
                    }
                }).catch((error: any) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            });
        }
    }

    protected selectVehicleModel() {
        if (this.vehicleModel?.bodyType?.name && this.vehicleModel?.carClass?.name && this.vehicleModel?.modelSeries &&
            this.selectedBrand?.name) {
            this.retailerService.selectVehicleModel(
                this.vehicleModel?.bodyType?.name, this.vehicleModel?.carClass?.name, this.vehicleModel?.modelSeries,
                this.selectedBrand.name, this.isManufakturSwitchOn, this.isStandardSwitchOn,
                this.isManufakturExclusiveSwitchOn
            )
                .then(() => {
                }).catch((error: any) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            });
        }
    }


    public onSwitchChange(source: 'manufaktur' | 'standard' | 'exclusive'): void {

        // Check if toggling leads to all false
        const allOff = !this.isManufakturSwitchOn && !this.isStandardSwitchOn && !this.isManufakturExclusiveSwitchOn;

        if (allOff) {
            // Re-enable the one that was not toggled
            switch (source) {
                case 'manufaktur':
                    this.isStandardSwitchOn = true;
                    break;
                case 'standard':
                    this.isManufakturSwitchOn = true;
                    break;
                case 'exclusive':
                    this.isManufakturSwitchOn = true;
                    break;
            }
        }

        this.selectVehicleModel();
    }

    /**
     * Handles the event when the user changes the studio.
     * Redirect to the retailer home page.
     */
    public onNewStudio() {
        this.router.navigate([ '/retailer' ]).then();
    }
}
